export const detectCalendarIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete calendar task" || cleaned === "remove calendar task") {
        return { intent: "delete_calendar_task" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) calendar task/);
    if (deleteMatch) {
        return { intent: "delete_calendar_task", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create calendar task") || cleaned.includes("add calendar task")) {
        return { intent: "create_calendar_task" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create calendar task named (.+)/);
    if (createMatch) {
        return { intent: "create_calendar_task", name: createMatch[1].trim() };
    }

    return null;
};
